const API_URL = process.env.REACT_APP_BACKEND_URL || "";
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem("token") || ""}`, "Content-Type": "application/json" });

export const alertasApi = {
  async carregar() {
    const r = await fetch(`${API_URL}/api/settings/alertas`, { headers: auth(), cache: "no-store" });
    if (!r.ok) throw new Error("Não foi possível carregar as configurações.");
    return r.json();
  },
  async salvar(parcial) {
    const r = await fetch(`${API_URL}/api/settings/alertas`, { method: "PUT", headers: auth(), body: JSON.stringify(parcial) });
    const d = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(d.detail || "Não foi possível salvar.");
    return d;
  },
};
